var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAiIcon = function SvgAiIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    fill: "none",
    viewBox: "0 0 22 22"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#6161FF",
    d: "M8.797 6.616a.213.213 0 0 1 .406 0l1.496 4.55a.21.21 0 0 0 .136.135l4.549 1.496a.213.213 0 0 1 0 .406l-4.55 1.496a.21.21 0 0 0-.135.136l-1.496 4.549a.213.213 0 0 1-.406 0l-1.496-4.55a.21.21 0 0 0-.136-.135l-4.549-1.496a.213.213 0 0 1 0-.406l4.55-1.496a.21.21 0 0 0 .135-.136z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#6161FF",
    d: "M16.297 2.616a.213.213 0 0 1 .406 0l.63 1.915a.21.21 0 0 0 .136.136l1.915.63a.213.213 0 0 1 0 .406l-1.915.63a.21.21 0 0 0-.137.136l-.63 1.915a.213.213 0 0 1-.405 0l-.63-1.915a.21.21 0 0 0-.136-.136l-1.915-.63a.213.213 0 0 1 0-.406l1.915-.63a.21.21 0 0 0 .136-.136z"
  })));
};
export default SvgAiIcon;